// @flow

import React from 'react'
import { containerIds } from 'modules/ui'
import PaymentMethod from './PaymentMethod'
import ContactPerson from './ContactPerson'
import Company from './Company'
import SMConst from 'frontend_core/dist/constants/sm-const'

type Props = {
  ui: {
    isChangedCompany: boolean,
  },
  company: {
    paymentMethod: number,
    paidCustomer: {},
  },
  onClickSave: Function,
  onChangeCompany: Function,
}

export default class SettingForm extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    e.preventDefault()
    const { actions } = this.props
    actions.setUIState(containerIds.BUSINESS_SETTING, {
      showSettingForm: false,
    })
  }

  render() {
    return (
      <div>
        <ul style={{ overflow: 'auto' }}>
          <li className="business-employee__list-tab-current">
            {i18n.t('page.employee.l_00027')}
          </li>
          <a href="" onClick={this.onClick}>
            <li className="business-employee__list-tab">
              {i18n.t('page.employee.l_00028')}
            </li>
          </a>
        </ul>
        <ul className="business-reservation-setting">
          <PaymentMethod {...this.props} />
          <ContactPerson {...this.props} />
          <Company {...this.props} />
        </ul>
        <div className="ta-c">
          <input
            className="button-green maincol-buttonarea__button business-reservation-setting__button"
            type="button"
            value={
              this.props.company.paymentMethod === SMConst.PaymentMethod.Card ||
              this.props.company.paidCustomer != null
                ? '保存する'
                : '保存して審査申請する'
            }
            onClick={this.props.onClickSave}
          />
        </div>
        {this.props.ui.isChangedCompany && (
          <p className="business-reservation-setting__paid-required">
            <i className="fa fa-exclamation-circle mr5" />
            法人情報を変更した場合はPaid上での変更も必要です。
            <br />
            保存後お手数ですが、Paidでも情報を変更してください。
          </p>
        )}
      </div>
    )
  }
}
